import PropTypes from "prop-types";
import { classNamePropType } from "../../common";
import { chartSeriesShape } from "../../shapes";

/**
 * PropTypes for ApexChart component
 *
 * @property {('line'|'area'|'bar'|'pie'|'donut'|'radar')} type - Chart type (required)
 * @property {Array<ChartSeries>} series - Chart data series (required)
 * @property {Object} [options] - ApexCharts options object
 * @property {number} [height] - Chart height in pixels
 * @property {number} [width] - Chart width in pixels or percentage string
 * @property {string} [className] - Additional CSS classes
 */
export const apexChartPropTypes = {
  type: PropTypes.oneOf(["line", "area", "bar", "pie", "donut", "radar"]).isRequired,
  series: PropTypes.arrayOf(chartSeriesShape).isRequired,
  options: PropTypes.object,
  height: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: classNamePropType,
};
